import { useTheme, Box, Typography, Button, TextField } from "@mui/material"; 
import { useState } from "react";

const Welcome = () => {
  const theme = useTheme(); 


  
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackEmail, setFeedbackEmail] = useState("");

  const handleSubmitFeedback = () => {
    
    
    
    setFeedbackMessage("");
    setFeedbackEmail("");
    
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: theme.palette.primary.main, 
        color: theme.palette.text.primary, 
      }}
    >
      {/* Welcome Section */}
      <Box sx={{ display: "flex", flexDirection: "column", p: 3, flexShrink: 0 }}>
        {/* Welcome Header */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
            Welcome
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: 2, color: theme.palette.text.primary }}>
          {/* Left Section */}
          <Box sx={{ gridColumn: "span 4" }}>
            {/* News and Tips Section */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 300, borderBottom: `1px solid ${theme.palette.divider}`, pb: 1 }}>
                News and Tips
              </Typography>
              <Box component="ul" sx={{ listStyle: "disc", pl: 4, mt: 2, "& li": { mb: 1 } }}>
                <Typography component="li" variant="body1">
                  <Button
                    variant="text"
                    sx={{
                      textTransform: "none",
                      textDecoration: "underline",
                      color: 'blue',
                      p: 0, minWidth: 0,
                    }}
                  >
                    How to install your hardware? (Video)
                  </Button>
                </Typography>
                <Typography component="li" variant="body1">
                  New with our tool? Make sure to test a propeller first!
                </Typography>
              </Box>
            </Box>

            {/* App Information Section */}
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 300, borderBottom: `1px solid ${theme.palette.divider}`, pb: 1 }}>
                App Information
              </Typography>
              <Box component="ul" sx={{ listStyle: "disc", pl: 4, mt: 2, "& li": { mb: 1 } }}>
                <Typography component="li" variant="body1">
                  <Button
                    variant="text"
                    sx={{
                      textTransform: "none",
                      textDecoration: "underline",
                      color: 'blue',
                      p: 0, minWidth: 0,
                    }}
                  >
                    Click Here for App Info!
                  </Button>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ mb: 3, mt: 6 }}>
              <Typography variant="h6" sx={{ fontWeight: 300, borderBottom: `1px solid ${theme.palette.divider}`, pb: 1 }}>
                Update
              </Typography>
              <Box sx={{ color: theme.palette.text.secondary, fontWeight: "light", mt: 1 }}>
                <Typography variant="body2">Current Version: 10.18</Typography>
                <Typography variant="body2">Latest Available: 10.18</Typography>
              </Box>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.primary.main, 
                  color: theme.palette.primary.contrastText, 
                  py: 1,
                  px: 4,
                  borderRadius: "8px",
                  mt: 2,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark, 
                  },
                }}
              >
                Software Download
              </Button>
            </Box>
          </Box>

          {/* Right Section  */}
          <Box sx={{ gridColumn: "span 3 / span 3", gridColumnStart: 6 }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 300, borderBottom: `1px solid ${theme.palette.divider}`, pb: 1 }}>
                Tell Us Something! Anything
              </Typography>
              <TextField
                name="feedback"
                id="feedback"
                multiline
                rows={4}
                fullWidth
                value={feedbackMessage}
                onChange={(e) => setFeedbackMessage(e.target.value)}
                placeholder="Type your feedback here..."
                sx={{
                  mt: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    backgroundColor: theme.palette.background.paper, 
                    color: theme.palette.text.primary,
                    "& fieldset": {
                      borderColor: theme.palette.divider, 
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.main, 
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: theme.palette.primary.main, 
                    },
                  },
                }}
                InputProps={{
                  style: { color: theme.palette.text.primary } 
                }}
                InputLabelProps={{
                  style: { color: theme.palette.text.secondary } 
                }}
              />
              <TextField
                type="email"
                placeholder="Email"
                fullWidth
                value={feedbackEmail}
                onChange={(e) => setFeedbackEmail(e.target.value)}
                sx={{
                  mt: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    backgroundColor: theme.palette.background.paper, 
                    color: theme.palette.text.primary,
                    "& fieldset": {
                      borderColor: theme.palette.divider,
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
                InputProps={{
                  style: { color: theme.palette.text.primary } 
                }}
                InputLabelProps={{
                  style: { color: theme.palette.text.secondary } 
                }}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={handleSubmitFeedback}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                  py: 1,
                  px: 4,
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

     
    </Box>
  );
};

export default Welcome;